import { ClientsFrameworkService } from ".";

export const ClientsFramework = new ClientsFrameworkService();
